<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <router-link :to="{name:'user-address'}" class="section">Piegādes adrese</router-link>
      <span class="divider">/</span>
      <div class="active section">Jauna adrese</div>
    </div>
  </div>

  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">
      <form class="ui form">
        <h3 class="ui dividing header">Pievienot jaunu adresi</h3>


        <div class="ui negative icon message" v-if="error">
          <i class="warning circle icon"></i>
          <div class="content">
          <div class="header">
            Lūdzu aizpildi visus laukus:
          </div>
          <ul class="list">
            <li v-for="item in error">{{item[0]}}</li>
          </ul>
        </div>
        </div>
          <div class="ui hidden divider"></div>
          <div class="field" >
            <div class="ui checkbox">
              <input id="newsletter" type="checkbox" v-model="addressItem.is_legal_address">
              <label for="newsletter">Juridiskā adrese</label>
            </div>
          </div>
         <div class="two fields">
           <div class="field">
             <label>Pilsēta</label>
             <select class="ui fluid dropdown" v-model="addressItem.city">
               <option value="">&nbsp;</option>
               <option v-for="item in city" v-bind:value="item.id">{{item.label}}</option>
             </select>
           </div>
           <div class="field">
             <label>Reģions</label>
             <select class="ui fluid dropdown" v-model="addressItem.region">
               <option value="">&nbsp;</option>
               <option v-for="item in filteredRegion" v-bind:value="item.id">{{item.label}}</option>
             </select>
           </div>
         </div>
         <div class="field">
           <div class="three fields">
             <div class="field">
               <label>Iela</label>
               <input type="text"  placeholder="Iela" v-model="addressItem.street">
             </div>
             <div class="field">
               <label>Mājas nr. / nosaukums</label>
               <input type="text"  placeholder="Mājas nr. / nosaukums" v-model="addressItem.house_no">
             </div>
             <div class="field">
               <label>Dzīvokļa nr.</label>
               <input type="text"  placeholder="Dzīvokļa nr." v-model="addressItem.flat_no">
             </div>
           </div>
         </div>
         <div class="field">
           <div class="two fields">
             <div class="field">
               <label>Tālrunis kurjeram</label>
               <input type="text"  placeholder="Norādiet tālruni kurjeram" v-model="addressItem.phone">
             </div>
             <div class="field">
               <label>Piezīmes</label>
               <input type="text"  placeholder="Piemēram, durvju kods" v-model="addressItem.notes">
             </div>
           </div>
         </div>
        <div class="ui right floated custom_brown button" @click="saveAddress">Saglabāt</div>
        <div class="ui clearing hidden divider"></div>
      </form>
  </div>

</div>
</template>

<script>
export default {
  data () {
    return {
      addressItem:{
          is_legal_address: 0,
          city: 0,
          region:0,
          street:'',
          house_no:'',
          flat_no:'',
          phone:'',
          notes:''
      }
    }

  },
  computed: {
    error() {
      return this.$store.state.addressStore.status.error
    },
    user() {
      return this.$store.state.userStore.user
    },
    storeStatus() {
      return this.$store.state.userStore.status
    },
    city() {
      return this.$store.state.addressStore.city
    },
    region() {
      return this.$store.state.addressStore.region
    },

    filteredRegion(){
      var self = this
      return self.$store.state.addressStore.region.filter(function(e) { return e.city_id == self.addressItem.city});
    },
  },

  activated: function() {

    //reset form
    Object.assign(this.$data, this.$options.data());
    //clear errors
    this.$store.commit('SET_ERROR', ''); //this will reet all errors

    //preload data
    this.$store.dispatch('loadUser').then((response) => {
       this.addressItem.phone = response.data.user.phone
    });
    this.$store.dispatch('loadCity');
    this.$store.dispatch('loadRegion');
  },

  methods: {
    saveAddress: function() {

      this.$store.dispatch('addAddress', this.addressItem).then((response) => {
            this.$router.push({
                name: 'user-address'
            });

      }).catch((error) => {
          console.error('Address was not saved')
      });

    }
  }
}
</script>



// WEBPACK FOOTER //
// UserAddressAddPage.vue?01b5b908